module.exports = __webpack_public_path__ + "assets/icona_pausa.e3320610.svg";